export default __webpack_public_path__ + "static/media/Launch.1cd68b5f.svg";